import { useState, ChangeEvent, useRef, useEffect } from 'react';
import { Button } from 'antd';
import { SKW_AUTH, SKW_PREFIX, SKW_URL } from '../../../../../../../utils/constants';
import { CloudUploadOutlined, SmileOutlined, FrownOutlined } from '@ant-design/icons';
import { Container } from './styles';
import { Props } from './types';
import { colorIconConversation, openNotification } from '../../../../../Utils';
import { ApplicationState } from '../../../../../../../store';
import { useSelector } from 'react-redux';
import { act } from 'react-dom/test-utils';

const FileUpload: React.FC<Props> = ({ hashAttachment, setHashAttachment }) => {
  const ocorrencia = useSelector((state: ApplicationState) => state.Ocorrencia?.data['ocorrencia']);
  const reader = new FileReader();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [file, setFile] = useState<File[]>([]);
  const [sendAttachment, setSendAttachment] = useState<boolean>(false);

  useEffect(() => {
    if (sendAttachment) {
      const getNamesFiles = hashAttachment.map((file) => file.nome);
      const maxLength = (file[0].size / 1024 / 1024).toFixed(2);
      const data = new FormData();

      file.forEach((file) => {
        if (getNamesFiles.includes(file.name)) {
          openNotification('Ops!', <FrownOutlined />, 'O arquivo já consta na lista de anexos');
          return reader.abort();
        }
        return data.append(file.name, file, file.name);
      });

      if (+maxLength > 5.0) {
        openNotification('Ops!', <FrownOutlined />, 'O arquivo deve ter no máximo 5MB');
        reader.abort();
      }
      act(() => {
        fetch(`${SKW_URL}/upload?serviceName=${SKW_PREFIX}novaMensagem&accessKey=${SKW_AUTH}`, {
          method: 'POST',
          body: data,
        })
          .then((res) => res.json())
          .then((data) => {
            setHashAttachment([
              ...hashAttachment,
              { key: data[0].filekey, nome: data[0].fileName },
            ]);
            openNotification('Arquivo(s) anexado(s) com sucesso', <SmileOutlined />);
            setSendAttachment(false);
          })
          .catch((err) => {
            reader.abort();
            openNotification('Ops!', <FrownOutlined />, 'Ocorreu um erro ao anexar o arquivo');
            setSendAttachment(false);
          });
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendAttachment]);

  const handleLoad = (): void => {
    setSendAttachment(true);
  };

  const handleError = (): void => {
    setSendAttachment(false);
    openNotification('Ops!', <FrownOutlined />, 'Ocorreu um erro ao anexar o arquivo');
  };

  function addListeners(reader: FileReader): void {
    reader.onload = () => handleLoad();
    reader.onerror = () => handleError();
  }

  const handleChangFile = (e: ChangeEvent<HTMLInputElement>): void => {
    setFile([]);
    if (!e.target.files) return;
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      addListeners(reader);
      reader.readAsDataURL(selectedFile);
      setFile([selectedFile]);
    } else {
      reader.abort();
    }
  };
  const color = colorIconConversation(ocorrencia?.urgencia);

  return (
    <Container>
      <input
        type="file"
        ref={inputRef}
        onChange={(e: ChangeEvent<HTMLInputElement>) => handleChangFile(e)}
        style={{ display: 'none' }}
        data-testid="upInput"
      />
      <Button
        type="ghost"
        icon={<CloudUploadOutlined style={{ color: color }} />}
        onClick={() => inputRef.current?.click()}
        data-testid="btnAttachment"
      >
        Anexar
      </Button>
    </Container>
  );
};

export default FileUpload;
